<template>
  <div>
    <site-header />
    <main class="policy-page">
      <section class="page-heading policy-hero">
        <p>Customer Care</p>
        <h1>Shipping Policy</h1>
        <span>Shipping, delivery, and order handling information.</span>
      </section>

      <section class="shipping-policy">
        <div class="policy-grid">
          <article>
            <h3>Shipping Delay Notice</h3>
            <p>Inventory is currently being transferred to a new fulfillment center. Some orders placed on or after June 30 may experience extended processing times. If affected, items are expected to ship within 14 to 21 days.</p>
          </article>
          <article>
            <h3>Free Standard Shipping</h3>
            <p>Free standard shipping is available on eligible orders of $75.00 or more after discounts and before taxes or shipping fees. Standard shipping must be selected during checkout.</p>
          </article>
          <article>
            <h3>Shipping Times</h3>
            <p>Business days are Monday through Friday, excluding holidays. Standard shipping is typically 5 to 9 business days after shipment. Express shipping is typically 2 to 3 business days after shipment.</p>
          </article>
          <article>
            <h3>Shipping Methods</h3>
            <p>Orders may ship using the most appropriate ground delivery method based on package weight and destination. Some items may ship separately or by an alternate carrier without additional shipping charges.</p>
          </article>
          <article>
            <h3>Rates</h3>
            <p>Standard Ground: $9.99. Express Shipping: $20.99. Express shipping is excluded from free standard shipping promotions.</p>
          </article>
          <article>
            <h3>Restrictions</h3>
            <p>Some items cannot ship to P.O. Boxes, APO/FPO addresses, or U.S. territories. Hazardous, aerosol, alcohol-based, oversized, or heavy items may be limited to ground shipping only.</p>
          </article>
          <article>
            <h3>Lost or Stolen Packages</h3>
            <p>Once an order leaves the warehouse, delivery is handled by the shipping carrier. Lost, stolen, delayed, damaged, or forwarded packages may need to be resolved directly with the carrier or forwarding service.</p>
          </article>
          <article>
            <h3>Additional Notes</h3>
            <p>Gift boxes and gift wrapping are not currently offered. Orders over $500 may require signature upon delivery. Multiple delivery addresses are not supported in a single order.</p>
          </article>
        </div>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'ShippingPolicy',
  components: { SiteHeader, SiteFooter }
}
</script>
